export default __webpack_public_path__ + "static/media/404.200b2716.jpg";